import { NextResponse } from 'next/server'
import { query, queryOne } from '@/lib/db'

export async function GET(req: Request) {
  const { searchParams } = new URL(req.url)
  const shopId = searchParams.get('shop_id')

  if (shopId) {
    const users = await query(
      'SELECT id, shop_id, name, role, created_at FROM shop_users WHERE shop_id = ? ORDER BY name',
      [shopId]
    )
    return NextResponse.json(users)
  }

  const shops = await query('SELECT * FROM shops ORDER BY name')
  return NextResponse.json(shops)
}

export async function POST(req: Request) {
  const { user_id, pin } = await req.json()
  const user = await queryOne(
    'SELECT id, shop_id, name, role, created_at FROM shop_users WHERE id = ? AND pin = ?',
    [user_id, pin]
  )
  if (!user) return NextResponse.json({ error: 'PIN incorrect' }, { status: 401 })

  const shop = await queryOne('SELECT * FROM shops WHERE id = ?', [user.shop_id])
  return NextResponse.json({ user, shop })
}
